module.exports = __webpack_public_path__ + "img/frame (205).dbfa4bde.jpg";